// Mock Data for Lease Management Dashboard

// Utilization Trends Data (Line Chart)
export const utilizationTrendsData = [
  { month: 'JAN', airframe: 20, engine1: 80, engine2: 190, lG: 200, aPU: 10 },
  { month: 'FEB', airframe: 30, engine1: 200, engine2: 180, lG: 190, aPU: 20 },
  { month: 'MAR', airframe: 40, engine1: 220, engine2: 200, lG: 210, aPU: 20 },
  { month: 'APR', airframe: 50, engine1: 110, engine2: 220, lG: 220, aPU: 240 },
  { month: 'MAY', airframe: 60, engine1: 130, engine2: 210, lG: 200, aPU: 50 },
  { month: 'JUN', airframe: 70, engine1: 140, engine2: 230, lG: 240, aPU: 60 },
  { month: 'JUL', airframe: 80, engine1: 250, engine2: 240, lG: 250, aPU: 20 }
];

// Invoices Amount Year Over Year Data (Bar Chart)
export const invoicesYOYData = [
  { year: '2017', amount: 65000 },
  { year: '2018', amount: 85000 },
  { year: '2019', amount: 45000 },
  { year: '2020', amount: 35000 },
  { year: '2021', amount: 25000 },
  { year: '2022', amount: 95000 },
  { year: '2023', amount: 98000 },
  { year: '2024', amount: 105000 },
  { year: '2025', amount: 30000 }
];

// Invoice Statistics
export const invoiceStats = {
  total: 2714,
  paid: 2714,
  unpaid: 2714,
  overdue: 2714
};

// Overdue Days Data
export const overdueDaysData = [
  { range: '1-30', count: 32 },
  { range: '< 60', count: 12 },
  { range: '> 90', count: 9 },
  { range: '< 120', count: 3 }
];

// MR Balance Data (Pie Chart)
export const mrBalanceData = [
  { name: 'Reserve', value: 25, color: '#3b82f6' },
  { name: 'Rental', value: 20, color: '#f59e0b' },
  { name: 'Adhoc', value: 18, color: '#ef4444' },
  { name: 'Credit', value: 17, color: '#10b981' },
  { name: 'Debit', value: 20, color: '#8b5cf6' }
];

// MR Balance Table Data
export const mrBalanceTableData = [
  { eventName: 'Airframe 6 Yr', balance: 'US$1,20,000' },
  { eventName: 'Airframe 12 Yr', balance: 'US$1,20,000' },
  { eventName: 'E1 PRSV', balance: 'US$1,20,000' },
  { eventName: 'E1 LLP Replacement', balance: 'US$1,20,000' },
  { eventName: 'E2 PRSV', balance: 'US$1,20,000' },
  { eventName: 'E2 LLP Replacement', balance: 'US$1,20,000' },
  { eventName: 'Landing Gear', balance: 'US$1,20,000' },
  { eventName: 'APU Overhaul', balance: 'US$1,20,000' }
];

// Cashflow Summary Data (Area Chart)
export const cashflowSummaryData = [
  { year: '2015', amount: 200 },
  { year: '2016', amount: 300 },
  { year: '2017', amount: 400 },
  { year: '2018', amount: 500 },
  { year: '2019', amount: 1300 },
  { year: '2020', amount: 600 },
  { year: '2021', amount: 800 },
  { year: '2022', amount: 1300 },
  { year: '2023', amount: 700 },
  { year: '2024', amount: 900 },
  { year: '2025', amount: 400 }
];

// Expiry of Documents Data
export const expiryDocumentsData = [
  { id: 1, documentType: 'Security Deposit', documentName: 'Letter of Credit', expiryDate: '20th Jan 2026', renewalDate: '1st Feb 2026' },
  { id: 2, documentType: 'Insurance', documentName: 'Insurance Copy', expiryDate: '20th Jan 2026', renewalDate: '1st Feb 2026' },
  { id: 3, documentType: 'Lease Option', documentName: 'Document Name', expiryDate: '20th Jan 2026', renewalDate: '1st Feb 2026' },
  { id: 4, documentType: 'Document Type', documentName: 'Document Name', expiryDate: '20th Jan 2026', renewalDate: '1st Feb 2026' },
  { id: 5, documentType: 'Document Type', documentName: 'Document Name', expiryDate: '20th Jan 2026', renewalDate: '1st Feb 2026' },
  { id: 6, documentType: 'Document Type', documentName: 'Document Name', expiryDate: '20th Jan 2026', renewalDate: '1st Feb 2026' }
];

// EOL Condition Data (Updated to 3 columns)
export const eolConditionData = [
  { id: 1, conditionName: 'Airframe End of Lease Check', eolValue: '$125,000', eolMatch: '95%' },
  { id: 2, conditionName: 'Engine 1 Performance Restoration', eolValue: '$450,000', eolMatch: '88%' },
  { id: 3, conditionName: 'Engine 2 Performance Restoration', eolValue: '$430,000', eolMatch: '92%' },
  { id: 4, conditionName: 'Landing Gear Overhaul', eolValue: '$85,000', eolMatch: '98%' },
  { id: 5, conditionName: 'APU Condition Assessment', eolValue: '$65,000', eolMatch: '90%' },
  { id: 6, conditionName: 'Interior Refurbishment', eolValue: '$220,000', eolMatch: '85%' },
  { id: 7, conditionName: 'Avionics System Upgrade', eolValue: '$180,000', eolMatch: '87%' },
  { id: 8, conditionName: 'Cabin Pressurization Check', eolValue: '$45,000', eolMatch: '96%' },
  { id: 9, conditionName: 'Hydraulic System Inspection', eolValue: '$75,000', eolMatch: '93%' },
  { id: 10, conditionName: 'Electrical System Overhaul', eolValue: '$95,000', eolMatch: '89%' }
];

// Add more realistic data for better testing
for (let i = 7; i <= 100; i++) {
  expiryDocumentsData.push({
    id: i,
    documentType: ['Security Deposit', 'Insurance', 'Lease Option', 'Document Type'][Math.floor(Math.random() * 4)],
    documentName: `Document ${i}`,
    expiryDate: `${Math.floor(Math.random() * 28) + 1}th ${['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'][Math.floor(Math.random() * 6)]} 2026`,
    renewalDate: `${Math.floor(Math.random() * 28) + 1}st ${['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'][Math.floor(Math.random() * 6)]} 2026`
  });
}

const conditionNames = [
  'Airframe End of Lease Check',
  'Engine Performance Restoration',
  'Landing Gear Overhaul',
  'APU Condition Assessment',
  'Interior Refurbishment',
  'Avionics System Upgrade',
  'Cabin Pressurization Check',
  'Hydraulic System Inspection',
  'Electrical System Overhaul',
  'Flight Control System Check'
];

// Add more realistic data for better testing
for (let i = 7; i <= 100; i++) {
  eolConditionData.push({
    id: i,
    documentType: conditionNames[Math.floor(Math.random() * 4)],
    documentName: `Document ${i}`,
    expiryDate: `${Math.floor(Math.random() * 28) + 1}th ${['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'][Math.floor(Math.random() * 6)]} 2026`,
    renewalDate: `${Math.floor(Math.random() * 28) + 1}st ${['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'][Math.floor(Math.random() * 6)]} 2026`
  });
}

